type Column = {
  accessor: string | (() => string);
};

type DataRow = Record<string, string>;

/**
 * @description
 * Sanitize column name to be used as a key in the data table.
 * This function replaces characters: [ ] . with _
 * Ref: https://github.com/TanStack/table/issues/3087
 */
function sanitizeColumn(name: string) {
  return name.replace(/[[\].]/g, "_");
}

function sanitizeTable(columns: Column[], data: DataRow[]) {
  columns.forEach(column => {
    if (typeof column.accessor === "function" || !column.accessor) {
      return;
    }
    column.accessor = sanitizeColumn(column.accessor);
  });

  data.forEach(row => {
    Object.keys(row).forEach(key => {
      const newKey = sanitizeColumn(key);
      if (newKey !== key) {
        row[newKey] = row[key];
        delete row[key];
      }
    });
  });
}

export { sanitizeColumn, sanitizeTable };
